module.exports = __webpack_public_path__ + "img/teaching_3.d3910ab1.png";